module.exports = __webpack_public_path__ + "resources/d7ae3fd2087dcd05df0b392add3f3cda.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/hostage.png
// module id = 212
// module chunks = 0